import React from 'react';

export default function index() {
  return (
    <div className="page-404">
      <h1>404</h1> <br /> <p>this page is not found</p> <a href="/">Home</a>
    </div>
  );
}
